import React from "react";
import { StyleSheet, type TextProps } from "react-native";
import { ThemedText } from "../themed-text";
import Fontisto from "@react-native-vector-icons/fontisto";
import { BrandColors } from "@/constants/theme";

interface LabelProps extends TextProps {
  label: string;
  required?: boolean;
}

export function Label({ label, style, required=true, ...rest }: LabelProps) {
  return (
    <ThemedText
      style={[styles.label, style]}
      type="smallSemiBold"
      accessible
      accessibilityRole="header"
      {...rest}
    >
      {label}{" "}
      {required && <Fontisto name="asterisk" size={10} color={BrandColors.error} />}
    </ThemedText>
  );
}

const styles = StyleSheet.create({
  label: {
    fontWeight: "600",
  },
});
